import React from 'react';

import { AppLayout } from 'AWS-UI-Components-React';
import { getCurrentStage } from '../../utilities';

import { QsEmbedder } from './qsembedder';

export class DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitted: false,
      quicksighterror: false,
      payload: {},
    };
    document.title = 'Phoenix : ' + getCurrentStage() === 'PROD' ? 'Usage Metrics' : 'Contra Cogs Bridging';
  }

  render() {
    return (
      <div>
        <AppLayout
          className="awsui-util-no-gutters"
          content={ <QsEmbedder payload={ this.state.payload } identity={ this.props.identity } /> }
          navigationHide={ true }
          toolsHide={ true } />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contra_cogs/dashboardcontainer.jsx